//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
    name: 'CurrencyList',
    data() {
        return {
            currency: '',
            topCurrency: {},
            amountOfInvestment: '',
            investmentPeriod: '',
            rate: '',
        };
    },
    mounted() {
    },
    computed: {
        ...mapState([ 'currencies' ]),
    },
    methods: {
    },

};
